import React from 'react'
import { Paper, Button, Dialog, TableCell, TableRow, DialogContent, DialogTitle, DialogActions, Grid, TextField, CircularProgress, InputAdornment } from '@material-ui/core';
import { EmptyCollection, TableListComp } from '../../../shared_elements';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
export default function GraphTableList({ graphList, setGraphListData, exportGraphListFn }) {
    return (
        <div>
            <Dialog
                open={graphList?.flag}
                onClose={() => setGraphListData({ modal: false })}
                className='console-management-modal'
                maxWidth='md'
            >
                <DialogTitle id="scroll-dialog-title" dividers={true}>
                    <div style={{ display: 'flex', justifyContent: "space-between" }}>
                        {graphList?.name} <span>
                            <Button size='small' variant='outlined' color='primary' onClick={() => {exportGraphListFn({data:graphList?.data, name:graphList?.name}) }}><SaveAltIcon style={{fontSize:'1.15rem',marginInlineEnd:'2px'}}/>Export</Button>
                        </span>
                    </div>
                </DialogTitle>
                <DialogContent dividers={true}>
                    <TableListComp
                        heads={graphList?.data?.columns.map(item => {return {label:item} })}
                        data={graphList?.data?.list_data.map(item =>
                            <TableRow >
                                <TableCell>{item?.x_data}</TableCell>
                                {
                                    item?.total_sv_cost ?
                                    <TableCell>{item?.total_sv_cost}</TableCell>
                                :
                                <TableCell>{item?.total_mr_rate}</TableCell>
                                }

                            </TableRow>
                        )}
                        noRecord={graphList?.data?.list_data?.length ? null : <EmptyCollection title="No Data Found!" />}
                    />
                </DialogContent>
                <DialogActions style={{ padding: '8px 24px' }}>
                    <Button size='small' variant='contained' color='primary' onClick={() => setGraphListData({ modal: false })}> Okay</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
